import { isNullOrEmpty } from '../../utils/arrays';

export const isTeacherWithoutClass = (role, localClasses) => {
  return role === 'TEACHER' && isNullOrEmpty(localClasses);
};

// A menu icon turns purple whenever its row is highlighted, and on any page
// under its link (a rubric's own page keeps the Rubrics icon purple).
export const showSelectedIcon = (subLink, pathname, isActive) =>
  isActive ||
  pathname === subLink.matchLink ||
  pathname.startsWith(`${subLink.matchLink}/`);

export const isActiveButton = (subLink, pathname, isTeacherNoClass) => {
  return (
    subLink.matchLink === pathname ||
    (isTeacherNoClass &&
      pathname === '/' &&
      subLink.matchLink === '/giveFeedback') ||
    (subLink.matchLink === '/tools/rubrics' && pathname.startsWith('/tools/rubrics')) ||
    (subLink.matchLink === '/tools/commentbanks' && pathname.startsWith('/tools/commentbanks')) ||
    (subLink.matchLink === '/tools/successcriterias' && pathname.startsWith('/tools/successcriterias')) ||
    (subLink.matchLink === '/tools/shortanswers' && pathname.startsWith('/tools/shortanswers'))
  );
};

// Flattens menu sections into one list, putting a { heading } entry before
// each section that has at least one item left after permission checks.
export const withSectionHeadings = (sections) =>
  sections.flatMap(({ heading, items }) => {
    const visibleItems = items.filter(Boolean);
    return visibleItems.length ? [{ heading }, ...visibleItems] : [];
  });

// The Tasks menu, grouped and ordered as in Figma 7621:43489. Items are found
// by link, never by position in a sub-links array, so reordering that array
// can't swap one menu item (and its permission check) for another.
export const buildTasksMenu = ({
  findLink,
  currentTasksLink,
  isStudent,
  canView = () => true,
}) =>
  withSectionHeadings([
    {
      heading: 'School work',
      items: [
        canView('currentTasks') && findLink(currentTasksLink),
        canView('closedTasks') && findLink('/completed'),
        canView('sharedResponses') && findLink('/sharedresponses'),
        findLink('/sharedtasks'),
      ],
    },
    {
      heading: isStudent ? 'Feedback requests' : 'Student requests',
      items: [
        canView('feedbackRequests') && findLink('/giveFeedback'),
        canView('feedbackHistory') && findLink('/feedbackHistory'),
      ],
    },
  ]);
